import React, {Fragment, PureComponent} from 'react';
import StatisticShow from "./statistic_show";
import logo from "../../logo.jpg";

class Index extends PureComponent {
    state = {
        loading: false,
        data: null,
        find_data: null,
        search_lab_kayit: ''
    };

    updateInputValue = (evt) => {
        this.setState({
            search_lab_kayit: evt.target.value
        });
    };

    getDataHandler = (LabKayitNo) => {
        const el = this;
        this.setState({loading: true});

        let xhr = new XMLHttpRequest();
        xhr.open('GET', 'http://78.186.191.124:2601/DinamikRapor.ashx?SORGU=Json_Analiz');

        xhr.onreadystatechange = function() {

            // request completed?
            if (xhr.readyState !== 4) return;

            if (xhr.status === 200) {
                // request successful - show response
                el.setState({data: JSON.parse(xhr.response)});
                el.setState({loading: false});

                el.findDataKey(LabKayitNo)
            }
            else {
                // request error
                console.log('HTTP error', xhr.status, xhr.statusText);
            }
        };

        xhr.send();

    };

    findDataKey = (LabKayitNo) => {
        if(!this.state.data){
            this.getDataHandler(LabKayitNo);
        }else{
            const data = this.state.data['json_analiz'];
            const el = this;
            el.setState({loading: true});
            el.setState({find_data: null});
            Object.keys(data).forEach(function (key) {
                if (LabKayitNo === data[key]['LabKayitNo']) {
                    el.setState({find_data: data[key]});
                    el.setState({loading: false});
                }else{
                    el.setState({loading: false});
                }
            });
        }

    };

    render() {
        let {loading, find_data} = this.state;


        return (
            <Fragment>
                <div className="row">
                    <div className="col-12">
                        <a href="https://www.bantb.org.tr/">
                            <img src={logo} alt="" style={{height: '130px'}}/>
                        </a>
                    </div>
                </div>

                <hr/>

                <div className="row mb-3">

                    <div className="col-3 themed-grid-col">
                        <h2 className="mt-1 no-print">Lütfen Analiz Kayıt No Giriniz.</h2>

                        <Fragment>
                            <form
                                className="input-group mb-3 no-print"
                                onSubmit={ e => { this.findDataKey(this.state.search_lab_kayit); e.preventDefault(); }}
                            >
                                <input type="text" className="form-control"
                                       value={this.state.search_lab_kayit}
                                       onChange={evt => this.updateInputValue(evt)}

                                       aria-describedby="button-addon2" />
                                <div className="input-group-append">
                                    {loading ? (
                                        <div className="spinner-border" role="status">
                                            <span className="sr-only">yükleniyor...</span>
                                        </div>
                                    ):(
                                        <button className="btn btn-outline-secondary"
                                                onClick={() => this.findDataKey(this.state.search_lab_kayit)}
                                                type="button">
                                            Ara
                                        </button>
                                    )}

                                </div>
                            </form>



                            <StatisticShow data={find_data}/>
                        </Fragment>
                    </div>



                </div>
            </Fragment>

        );
    }
}


export default Index;
